export const DATE_PATTERN = '[0-9]{4}-[0-9]{2}-[0-9]{2}'
export const PHONE_PATTERN = '.*'
export const ZIPCODE_PATTERN = '.*'
